module.exports = __webpack_public_path__ + "static/media/7.ecadf6af.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/hats/7.png
// module id = 745
// module chunks = 0